import React from 'react';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { isExternalPath, localizePath } from '../../helper/localizedPath';

export default function Button({ btnLink, btnOnClick, btnText, variant, icon }) {
  const { i18n } = useTranslation();
  const targetLink = localizePath(btnLink, i18n.language === 'en' ? 'en' : 'cs');

  if (isExternalPath(btnLink)) {
    return (
      <a
        href={btnLink}
        onClick={btnOnClick}
        className={variant ? `cs-text_btn ${variant}` : 'cs-text_btn'}
      >
        <span>{btnText}</span>
        {icon ? icon : <Icon icon="bi:arrow-right" />}
      </a>
    );
  }

  return (
    <Link
      to={targetLink}
      onClick={btnOnClick}
      className={variant ? `cs-text_btn ${variant}` : 'cs-text_btn'}
    >
      <>
        <span>{btnText}</span>
        {icon ? icon : <Icon icon="bi:arrow-right" />}
      </>
    </Link>
  );
}
